import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import AlertContent from './AlertContent';
import { dismissAlert } from 'reducers/alerts/actions';
import { map } from 'lodash';

const styles = {
  alertsWrapper: {
    bottom: '15px',
    position: 'fixed',
    right: '15px',
  },
};

const Alerts = ({ alerts, classes, dismissAlert }) => {
  return (
    <div className={classes.alertsWrapper}>
      {map(alerts, (alert, index) => (
        <AlertContent
          key={alert.id}
          message={alert.message}
          onClose={() => dismissAlert(alert.id)}
          variant={alert.type}
        />
      ))}
    </div>
  );
};

Alerts.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    message: PropTypes.node.isRequired,
    type: PropTypes.oneOf([
      'error',   // vermelho
      'info',    // azul
      'success', // verde
      'warning', // amarelo
    ]).isRequired,
  })),
  classes: PropTypes.object.isRequired,
  dismissAlert: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  alerts: state.alerts,
});

const mapDispatchToProps = { dismissAlert };

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Alerts));



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Alert/Alerts.js